import { render, staticRenderFns } from "./ETituloSecaoAEE.vue?vue&type=template&id=a132c97e"
import script from "./ETituloSecaoAEE.vue?vue&type=script&lang=js"
export * from "./ETituloSecaoAEE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports